var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPenEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5528 3.10557C14.8343 2.96481 15.1657 2.96481 15.4472 3.10557L20.8944 5.82918C21.572 6.16796 22 6.86049 22 7.61803V18.382C22 19.8687 20.4354 20.8357 19.1056 20.1708L15 18.118L14.4743 17.7931C14.1795 17.6109 14 17.289 14 16.9425V5.61803L10 7.61803V9C10 9.55228 9.55228 10 9 10C8.44772 10 8 9.55228 8 9V7.61803L4 5.61803V11C4 11.5523 3.55228 12 3 12C2.44772 12 2 11.5523 2 11V5.61803C2 4.13127 3.56462 3.16428 4.89443 3.82918L9 5.88197L14.5528 3.10557ZM20 7.61803L16 5.61803V16.382L20 18.382V7.61803Z",
    fill: "#2C3236"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1213 11.8787C9.94975 10.7071 8.05025 10.7071 6.87868 11.8787L2.29289 16.4645C2.10536 16.652 2 16.9064 2 17.1716V20C2 20.5523 2.44772 21 3 21H5.82842C6.09364 21 6.34799 20.8946 6.53553 20.7071L11.1213 16.1213C12.2929 14.9497 12.2929 13.0503 11.1213 11.8787ZM4 17.5858L8.29289 13.2929C8.68342 12.9024 9.31658 12.9024 9.70711 13.2929C10.0976 13.6834 10.0976 14.3166 9.70711 14.7071L5.41421 19H4L4 17.5858Z",
    fill: "#2C3236"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPenEdit);
export default __webpack_public_path__ + "static/media/map-pen-edit.2ae7dafb58fb78c4ee55f4c7c4a96fae.svg";
export { ForwardRef as ReactComponent };